import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./inventory.css";

export default function InventoryAdd() {
  const school   = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [saving,     setSaving]     = useState(false);
  const [form, setForm] = useState({
    name: "", description: "", category: "",
    quantity: "", purchase_price: "",
    vendor: "", purchase_date: "",
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const loadCategories = async () => {
    try {
      const res = await API.get("/school-admin/inventory/categories/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setCategories(res.data.categories || []);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { loadCategories(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return alert("Item name is required");
    try {
      setSaving(true);
      await API.post("/school-admin/inventory/items/", form, {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      navigate("/school-admin/inventory");
    } catch (err) { console.error(err); alert("Error adding item"); }
    finally { setSaving(false); }
  };

  return (
    <div className="inv-page">

      {/* ══ HERO ══ */}
      <div className="inv-hero">
        <div className="inv-hero-left">
          <div className="inv-hero-icon">➕</div>
          <div>
            <h2 className="inv-hero-title">Add Inventory Item</h2>
            <p className="inv-hero-sub">Record a new item with purchase details</p>
          </div>
        </div>
        <div className="inv-hero-right">
          <button className="inv-btn-back" onClick={() => navigate("/school-admin/inventory")}>
            ← Back
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="inv-form-card">
          <p className="inv-form-section-title">Item Details</p>

          <div className="inv-grid-2">
            <div className="inv-field">
              <label>Item Name *</label>
              <input
                required
                placeholder="e.g. Science Lab Kit"
                value={form.name}
                onChange={e => set("name", e.target.value)}
              />
            </div>
            <div className="inv-field">
              <label>Category</label>
              <select value={form.category} onChange={e => set("category", e.target.value)}>
                <option value="">— Select Category —</option>
                {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
            <div className="inv-field">
              <label>Quantity</label>
              <input
                type="number" min="0"
                placeholder="0"
                value={form.quantity}
                onChange={e => set("quantity", e.target.value)}
              />
            </div>
            <div className="inv-field">
              <label>Purchase Price (₹)</label>
              <input
                type="number" min="0" step="0.01"
                placeholder="0.00"
                value={form.purchase_price}
                onChange={e => set("purchase_price", e.target.value)}
              />
            </div>
            <div className="inv-field">
              <label>Vendor</label>
              <input
                placeholder="Vendor or supplier name"
                value={form.vendor}
                onChange={e => set("vendor", e.target.value)}
              />
            </div>
            <div className="inv-field">
              <label>Purchase Date</label>
              <input
                type="date"
                value={form.purchase_date}
                onChange={e => set("purchase_date", e.target.value)}
              />
            </div>
            <div className="inv-field inv-field-full">
              <label>Description</label>
              <textarea
                placeholder="Additional notes about the item…"
                value={form.description}
                onChange={e => set("description", e.target.value)}
              />
            </div>
          </div>

          <button type="submit" className="inv-btn-submit" disabled={saving}>
            {saving
              ? <><div className="inv-spinner"></div> Saving…</>
              : "✓ Save Item"
            }
          </button>
        </div>
      </form>

    </div>
  );
}
